import React from "react";
import Upload from "../../components/Files/upload";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import UploadBase64 from "../../components/Files/FileBase64";

const DOCOnlineUploadDocuments = ({ docOnline, setDocOnline, companyId }) => {
  const { t } = useTranslation();
  const deleteFile = () => {
    const { fileBase64, ...docOnlineWithoutFile } = docOnline;
    setDocOnline(docOnlineWithoutFile);
  };

  function setFile(file) {
    setDocOnline({ ...docOnline, fileBase64: file[0] });
  }

  return (
    <>
      <div className="doc-subtitle subtitle-style">
        {t("Finally, we reinforce the importance of reviewing the completion of the document, regarding to the professional experience. Thank you very much!")}
      </div>
      <div className="card doc-inboard p-4">
        <div className="mb-2">
          {t("If you want to attach your CV here")}:
          {docOnline.fileBase64?.fileName}
        </div>
        <UploadBase64
          multiple={false}
          afterLoadCallback={setFile}
          accept="application/pdf, application/msword, application/xml, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          deleteFile={() => deleteFile()}
        />
      </div>
    </>
  );
};

export default DOCOnlineUploadDocuments;

DOCOnlineUploadDocuments.prototype = {
  docOnline: PropTypes.object.isRequired,

  setDocOnline: PropTypes.func.isRequired
};
